// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__n88WG","unreadBadge":"styles_unreadBadge__kPqds","modalContent":"styles_modalContent__3yR3U","modal":"styles_modal__2Ry3J"};